import { render, staticRenderFns } from "./FilterSidebarColors.vue?vue&type=template&id=39e4772e&scoped=true"
import script from "./FilterSidebarColors.vue?vue&type=script&lang=js"
export * from "./FilterSidebarColors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e4772e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39e4772e')) {
      api.createRecord('39e4772e', component.options)
    } else {
      api.reload('39e4772e', component.options)
    }
    module.hot.accept("./FilterSidebarColors.vue?vue&type=template&id=39e4772e&scoped=true", function () {
      api.rerender('39e4772e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/Components/FilterSidebarColors.vue"
export default component.exports